/**
 * Values used by the JSON-LD builders that have no counterpart in the product
 * or store data, and therefore cannot be derived at runtime.
 *
 * ⚠ The three blocks below are placeholders taken from the SEO specification.
 * They are published to Google as factual claims about the shop, so they must
 * be confirmed by the business before going to prod:
 *  - PRICE_VALIDITY_DAYS: no price-validity date exists in the product data
 *  - SHIPPING_POLICY.rateValue: 0 claims unconditional free shipping, while the
 *    real policy is free above a 300 € order
 *  - RETURN_POLICY.days: example value, not the actual Millésima return window
 */

/** Fragment identifiers of the entities shared by every offer of a page. */
export const STRUCTURED_DATA_ID = {
	SHIPPING_POLICY: '#shipping_policy',
	RETURN_POLICY: '#return_policy',
};

/** How long a displayed price is announced as valid, in days. */
export const PRICE_VALIDITY_DAYS = 365;

export const SHIPPING_POLICY = {
	rateValue: 0,
	handlingTimeDays: { min: 1, max: 2 },
	transitTimeDays: { min: 3, max: 5 },
};

export const RETURN_POLICY = {
	days: 14,
	category: 'https://schema.org/MerchantReturnFiniteReturnWindow',
	method: 'https://schema.org/ReturnByMail',
	fees: 'https://schema.org/FreeReturn',
};
